import React, { useState, useEffect } from 'react';
import Loader from '../../Search/Loader';
import TeamSeasonsRow from './TeamSeasonsRow';

const TeamSeasonsTable = ({ team, permalink, title }) => {
    const [loading, setLoading] = useState(true);
    const [teamId, setTeamId] = useState(team);
    const [seasonsData, setSeasonsData] = useState([]);
    const [seriesIndex, setSeriesIndex] = useState(0);
    const [viewAll, setViewAll] = useState(false);

    useEffect(() => {
        fetch(`${wp_ajax.db_ajax_url}?action=fetch_database_team_seasons&team_id=${teamId}`)
            .then(res => res.json())
            .then(response => {
                setSeasonsData(response.data);
                setLoading(false);

                if (Object.entries(response.data[seriesIndex].seasons).length < 3) {
                    setViewAll(true);
                }
            });
    }, []);

    if (loading) {
        return <Loader />;
    }

    const filterResults = e => {
        const seriesIndexValue = e.target.value || 0;
        setSeriesIndex(seriesIndexValue);

        const viewAllValue = Object.entries(seasonsData[seriesIndexValue].seasons).length < 3;
        setViewAll(viewAllValue);
    };

    const seasonsDataResults = () => {
        if (viewAll) {
            return Object.entries(seasonsData[seriesIndex].seasons);
        }

        return Object.entries(seasonsData[seriesIndex].seasons).slice(0, 3);
    };

    const toggleSection = e => {
        e.preventDefault();
        e.target.closest('.toggle').classList.toggle('open');
    };

    return (
        <>
            <header className="content-header content-header--alt">
                <h2 className="content-header__small-title sanomat">{ title ? title : ( "Championship Seasons" ) }</h2>
                <div className="content-header__dropdown database-table-collapsible__toggles proxima">
                    <a href="#" className="database-table-collapsible__more" onClick={toggleSection}>
                        Show
                    </a>
                    <a href="#" className="database-table-collapsible__less" onClick={toggleSection}>
                        Hide
                    </a>
                </div>
                <div className="content-header__footer select-wrapper">
                    <select data-behaviour="dropdown-toggle" onChange={filterResults}>
                        {seasonsData.map((data, index) => (
                            <option key={index} data-ref={index} value={index}>
                                {data.series}
                            </option>
                        ))}
                    </select>
                </div>
            </header>

            <div className="database-table-collapsible__table">
                <table className="database-table database-table--nested">
                    <thead>
                        <tr className="proxima">
                            <th>Season</th>
                            <th>Driver</th>
                            <th className="u-hidden-mobile">Races</th>
                            <th className="u-hidden-mobile">Entrant</th>
                            <th>Teams Pos</th>
                            <th>Driver Pos</th>
                            <th>Results</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Object.entries(seasonsData[seriesIndex].seasons).length > 0 &&
                            seasonsDataResults().map(([key, value], index) => (
                                <TeamSeasonsRow key={`${key}_${index}`} teamId={teamId} season={value} index={index} />
                            ))}
                        {Object.entries(seasonsData[seriesIndex].seasons).length < 1 && (
                            <tr>
                                <td colSpan="9">No results available in the database</td>
                            </tr>
                        )}
                    </tbody>
                </table>
                {!viewAll && (
                    <>
                        <br />
                        { permalink ? (
                            <a href={permalink} className="button button--outline">
                                View all results
                            </a>
                        ) : (
                            <a onClick={() => setViewAll(true)} className="button button--outline">
                                View all results
                            </a>
                        ) }
                    </>
                )}
                
                { permalink && viewAll ? (
                    <>
                        <br />
                        <a href={permalink} className="button button--outline">
                            View more
                        </a>
                    </>
                ): '' }
            </div>
        </>
    );
};

export default TeamSeasonsTable;
